export default {
    Metadata: {
        Name: "ToInt",
        Description: "Returns the given value as an integer.",
        Syntax: "ToInt(value)",
        Keywords: ['Conversion', 'Integer'],
        Author: "DataVoke, Inc.",
    },
    execute(fromValue) {
        return parseInt(fromValue);
    },
};

